const convertNullsToZeroNested = (nestedObj = {}) => {
    const cleaned = {};
    for (const key in nestedObj) {
        const val = nestedObj[key];
        if (Array.isArray(val)) {
            cleaned[key] = val.map(v => (v === null ? 0 : v));
        } else if (typeof val === 'object' && val !== null) {
            cleaned[key] = convertNullsToZeroNested(val); // recursive clean
        } else {
            cleaned[key] = val === null ? 0 : val;
        }
    }
    return cleaned;
};


export default convertNullsToZeroNested
